import {Hal} from './hal.model';

import {RequestInformationDisabledReasonEnum} from '../../enums/request-information-disabled-reason.enum';

export class CaseHal extends Hal {
  identification: string;
  name: string;
  description: string;
  reference: string;
  teamId: string;
  client: string;
  clientAdditionalInfo: string;
  creator: string;
  creationDate: Date;
  completedDate: Date;
  assignee: string;
  state: string;
  externalCaseId: string;
  informationLink: string;
  informationLinkLabel: string;
  informationLinkDate?: Date;
  requestInformationDisabledReason?: RequestInformationDisabledReasonEnum;
  downloadCaseZipFilenameTemplate: string;
  processingPhaseEnabled?: boolean;

  constructor(data: any) {
    super(data);
    this.identification = data.identification;
    this.name = data.name;
    this.description = data.description;
    this.reference = data.reference;
    this.teamId = data.teamId;
    this.client = data.client;
    this.clientAdditionalInfo = data.clientAdditionalInfo;
    this.creator = data.creator;
    this.assignee = data.assignee;
    this.creationDate = new Date(data.creationDate);
    this.completedDate = new Date(data.completedDate)
    this.state = data.state;
    this.externalCaseId = data.externalCaseId;
    this.informationLink = data.informationLink;
    this.informationLinkLabel = data.informationLinkLabel;
    this.informationLinkDate = data.informationLinkDate ? new Date(data.informationLinkDate) : undefined;
    this.requestInformationDisabledReason = data.requestInformationDisabledReason;
    this.downloadCaseZipFilenameTemplate = data.downloadCaseZipFilenameTemplate;
    this.processingPhaseEnabled = !!data.processingPhaseEnabled;
  }
}
